import { createAsyncThunk } from "@reduxjs/toolkit";
import { AppId, AppThunkAPIType } from "../../../app/appTypes";
import { getWithAuth } from "../../../http";

export interface DocumentTestTeam {
    id: string,
    userName: string,
    role: string,
    name: string,
    position: string,
    email: string,
    companyName: string,
}

export const loadDocumentTestTeam = createAsyncThunk<DocumentTestTeam[], { documentId: AppId; }, AppThunkAPIType>("document-test-team/loadDocumentTestTeam",
    async ({ documentId }, { dispatch, rejectWithValue }) => {
        const result = await dispatch(getWithAuth({
            url: `api/document-tests/${documentId}/test-team`,
        }))
        const { payload } = result
        if (getWithAuth.fulfilled.match(result)) {
            return payload as DocumentTestTeam[]
        } else {
            return rejectWithValue(payload ?? { kind: 'unknown' })
        }
    })
